import type { SxProps, Theme } from '@mui/material'

/** Campo de búsqueda de las tablas de listado (patrón de `customer-list`). */
export const listSearchSx: SxProps<Theme> = {
    '& .MuiInputBase-root': {
        backgroundColor: 'rgb(var(--k-surface))',
        color: 'rgb(var(--k-ink))',
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgb(var(--k-line-strong))',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgb(var(--k-muted))',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgb(var(--k-primary))',
    },
    '& .MuiInputLabel-root': {
        color: 'rgb(var(--k-muted))',
    },
    '& .MuiInputLabel-root.Mui-focused': {
        color: 'rgb(var(--k-primary-ink))',
    },
    '& .MuiInputBase-input': {
        color: 'rgb(var(--k-ink))',
    },
    width: '100%',
    maxWidth: 380,
}

/** Botón de acción por fila (Ver / Editar). */
export const rowActionSx: SxProps<Theme> = {
    width: 'auto',
    minWidth: 'auto',
    height: 36,
    padding: '0 12px',
    borderRadius: '10px',
    boxShadow: 'none',
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '13px',
    lineHeight: 1,
    backgroundColor: 'transparent',
    color: 'rgb(var(--k-ink))',
    border: '1px solid rgb(var(--k-line-strong))',
    '&:hover': {
        backgroundColor: 'rgb(var(--k-accent-soft))',
        border: '1px solid rgb(var(--k-primary))',
        color: 'rgb(var(--k-accent-ink))',
        boxShadow: 'none',
    },
}

/** Botón de acción destructiva por fila (Eliminar). */
export const rowDangerActionSx: SxProps<Theme> = {
    ...(rowActionSx as object),
    color: 'rgb(var(--k-danger-ink))',
    '&:hover': {
        backgroundColor: 'rgb(var(--k-danger-soft))',
        border: '1px solid rgb(var(--k-danger))',
        color: 'rgb(var(--k-danger-ink))',
        boxShadow: 'none',
    },
}
